import { Box } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IS_SA } from '../../../../../config/appConfig';
import { AppRoutes } from '../../../../../constants/appRoutes';
import { GTMEvents } from '../../../../../constants/gtmEvents';
import { InvestorChannels } from '../../../../../constants/investorChannels';
import { OTPTypes } from '../../../../../constants/otpTypes';
import { buildLocalizeRoute } from '../../../../../helpers/languageHelper';
import { pushToDataLayer, saveContactNumber } from '../../../../../helpers/pushToGTMHelper';
import { Logout, loginUsingToken } from '../../../../../services/authService';
import { UserService } from '../../../../../services/userService';
import { Toaster } from '../../../../../shared/components/common/toaster';
import { OTPAuthenticationDialog } from '../../../../../shared/components/otpAuthenticationDialog';
import { BaseRegistration } from '../../../core/baseRegistration';
import { SignupPageWrapper } from '../../../core/signUpPageWrapper';

export const InvestorBaseRegistration = () => {
	const userService = new UserService();
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);
	const [showOTPAuth, setShowOTPAuth] = useState(false);

	const onSubmit = (values) => {
		const data = {
			...values,
			referral: localStorage.getItem('ref'),
			channel: InvestorChannels.Core,
		};
		if (!data.termsConditionsForInvestmentsAccepted) {
			Toaster({ msg: t('termsAndConditionsRequired') });
			return;
		}

		setLoading(true);
		userService
			.registerInvestor(data)
			.then((resp) => {
				let tokenModel = resp.data;
				if (tokenModel) {
					setLoading(false);
					localStorage.removeItem('ref');
					const email = data.email;
					const phone = `+${data?.contactNumber?.code} ${data?.contactNumber?.number}`;
					saveContactNumber(phone);
					pushToDataLayer(GTMEvents.signUpSubmit, {
						userInfo: {
							email: email,
							phone: phone
						}
					});
					if (!resp.data?.emailConfirmed) {
						navigate(buildLocalizeRoute(`${AppRoutes.VerifyEmail}?e=${encodeURIComponent(data.email)}&type=2`));
					} else {
						loginUsingToken(tokenModel.token);
						if (tokenModel.otpRequested) {
							setShowOTPAuth(true);
						} else {
							onNavigateNextStep();
						}
					}
				}
			})
			.catch((err) => {
				setLoading(false);
			});
	};

	const onNavigateNextStep = () => {
		let route = `${AppRoutes.InvestorRegistration}/${IS_SA ? AppRoutes.IRegNafathVerification : AppRoutes.IRegPersonalInfo
			}`;
		navigate(buildLocalizeRoute(route));
	};

	return (
		<Box className="flex flex-col h-full">
			<SignupPageWrapper>
				<BaseRegistration
					loading={loading}
					clientType={'investor'}
					onSubmitForm={(values) => {
						onSubmit(values);
					}}></BaseRegistration>
			</SignupPageWrapper>
			{showOTPAuth ? (
				<OTPAuthenticationDialog
					type={OTPTypes.Authentication}
					onClose={(isVerified) => {
						setShowOTPAuth(false);
						if (isVerified) {
							onNavigateNextStep();
						} else {
							Logout();
							navigate(buildLocalizeRoute(AppRoutes.Login));
						}
					}}
					state={showOTPAuth}></OTPAuthenticationDialog>
			) : null}
		</Box>
	);
};
